import token, { tokenToVars } from '../token';
import Tree from './tree';

export { Tree };
export default tokenToVars(Tree, token);
